export default __webpack_public_path__ + "static/Silk-43a0671c7b63faf8a5551e0eabb1e3b3.png";